<template>
    <div class="orderDetailsDIV">
        <div class="orderDetails" v-if="isMobile == false">
            <div class="top">
                <div class="top-title">
                    <div class="title" style="flex: 1;">{{ $t('cart71') }}</div>
                    <div class="title statusW">{{ $t('number52') }}</div>
                </div>
                <div class="Order">
                    <div class="address">
                        <div class="content">
                            <div class="item">
                                <div class="Left">
                                    {{ $t('setup25') }}:
                                </div>
                                <div class="right">
                                    {{ payState(param.modelDetails.order.pay_type) }}

                                </div>
                            </div>
                            <div class="item"
                                v-if="param.modelDetails.order.pay_type == 2 && userStore.userInfo.userId != param.modelDetails.shop_user.shop_user_id">
                                <div class="Left">
                                    {{ $t('setup48') }}:
                                </div>
                                <div class="right">
                                    <span>{{ param.modelDetails.order.pay_result.bank_name }}
                                        <el-tooltip :content="param.modelDetails.order.pay_result.telegram"
                                            placement="top" effect="customized"
                                            v-if="param.modelDetails.order.pay_result.telegram">
                                            <a :href="param.modelDetails.order.pay_result.telegram" target="_blank"
                                                rel="nofollow" class="button" style="padding:0 10px;">
                                                <img src="../../assets/images/telegram.png"
                                                    style="width: 20px;height: 20px;" alt="" srcset="">
                                            </a>
                                        </el-tooltip>
                                        <el-tooltip :content="param.modelDetails.order.pay_result.watch_app"
                                            placement="top" effect="customized"
                                            v-if="param.modelDetails.order.pay_result.watch_app">
                                            <a :href="`${param.modelDetails.order.pay_result.watch_app}`"
                                                target="_blank" rel="nofollow" class="button" style="padding:0 10px;">
                                                <img src="../../assets/images/watch.png"
                                                    style="width: 20px;height: 20px;border-radius: 50%;    " alt=""
                                                    srcset="">
                                            </a>
                                        </el-tooltip>
                                    </span>

                                </div>
                            </div>
                            <div class="item">
                                <div class="Left">
                                    {{ $t('cart22') }}:
                                </div>
                                <div class="right">
                                    {{ param.modelDetails.shipping.shipping_name }}

                                </div>
                            </div>
                            <div class="item">
                                <div class="Left">
                                    {{ $t('cart23') }}:
                                </div>
                                <div class="right">
                                    {{ param.modelDetails.shipping.shipping_phone }}

                                </div>
                            </div>
                            <div class="item">
                                <div class="Left">
                                    {{ $t('number28') }}:
                                </div>
                                <div class="right" style="width: 433px;overflow-wrap: break-word;">
                                    {{ param.modelDetails.shipping.shipping_area }}

                                </div>
                            </div>
                            <div class="item">
                                <div class="Left">

                                    {{ $t('number45') }}:
                                </div>
                                <div class="right">

                                    {{ param.modelDetails.order.order_no }}

                                </div>
                            </div>
                            <div class="item" v-if="order_type == 2">
                                <div class="Left">
                                    {{ $t('cart72') }}:
                                </div>
                                <div class="right">
                                    51shopy
                                    <el-tooltip :content="param.contactData.telegram" placement="top"
                                        effect="customized" v-if="param.contactData.telegram">
                                        <a :href="`${param.contactData.telegram}`" target="_blank" rel="nofollow"
                                            class="button" style="padding:0 10px;">
                                            <img src="../../assets/images/telegram.png"
                                                style="width: 20px;height: 20px;" alt="" srcset="">
                                        </a>
                                    </el-tooltip>
                                    <el-tooltip :content="param.contactData.whats_app" placement="top"
                                        effect="customized" v-if="param.contactData.whats_app">
                                        <a :href="`${param.contactData.whats_app}`" target="_blank" rel="nofollow"
                                            class="button" style="padding:0 10px;">
                                            <img src="../../assets/images/watch.png"
                                                style="width: 20px;height: 20px;border-radius: 50%;    " alt=""
                                                srcset="">
                                        </a>
                                    </el-tooltip>

                                </div>
                            </div>
                            <div class="item"
                                v-if="userStore.userInfo.userId != param.modelDetails.shop_user.shop_user_id">
                                <div class="Left" v-if="order_type == 1">
                                    {{ $t('cart72') }}:
                                </div>
                                <div class="right" v-if="order_type == 1">
                                    {{ param.modelDetails.shop_user.shop_user }}
                                    <el-tooltip :content="param.modelDetails.shop_user.telegram" placement="top"
                                        effect="customized" v-if="param.modelDetails.shop_user.telegram">
                                        <a :href="`${param.modelDetails.shop_user.telegram}`" target="_blank"
                                            rel="nofollow" class="button" style="padding:0 10px;">
                                            <img src="../../assets/images/telegram.png"
                                                style="width: 20px;height: 20px;" alt="" srcset="">
                                        </a>
                                    </el-tooltip>
                                    <el-tooltip :content="param.modelDetails.shop_user.whats_app" placement="top"
                                        effect="customized" v-if="param.modelDetails.shop_user.whats_app">
                                        <a :href="`${param.modelDetails.shop_user.whats_app}`" target="_blank"
                                            rel="nofollow" class="button" style="padding:0 10px;">
                                            <img src="../../assets/images/watch.png"
                                                style="width: 20px;height: 20px;border-radius: 50%;    " alt=""
                                                srcset="">
                                        </a>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="item" v-else>
                                <div class="Left" v-if="order_type == 1">

                                    {{ $t('setup50') }}:
                                </div>
                                <div class="right" v-if="order_type == 1">
                                    {{ param.modelDetails.buy_user.user_name }}
                                    <el-tooltip :content="param.modelDetails.buy_user.telegram" placement="top"
                                        effect="customized" v-if="param.modelDetails.buy_user.telegram">
                                        <a :href="`${param.modelDetails.buy_user.telegram}`" target="_blank"
                                            rel="nofollow" class="button" style="padding:0 10px;">
                                            <img src="../../assets/images/telegram.png"
                                                style="width: 20px;height: 20px;" alt="" srcset="">
                                        </a>
                                    </el-tooltip>
                                    <el-tooltip :content="param.modelDetails.buy_user.whats_app" placement="top"
                                        effect="customized" v-if="param.modelDetails.buy_user.whats_app">
                                        <a :href="`${param.modelDetails.buy_user.whats_app}`" target="_blank"
                                            rel="nofollow" class="button" style="padding:0 10px;">
                                            <img src="../../assets/images/watch.png"
                                                style="width: 20px;height: 20px;border-radius: 50%;    " alt=""
                                                srcset="">
                                        </a>
                                    </el-tooltip>
                                </div>
                            </div>

                            <!-- 国内物流单号 -->
                            <div class="item" v-if="param.modelDetails.order.shipping_number">
                                <div class="Left">{{ $t('number77') }}</div>
                                <div class="right">{{ param.modelDetails.order.shipping_number }}</div>
                            </div>
                            <!-- 国际物流单号 -->
                            <div class="item" v-if="param.modelDetails.order.intl_shipping_number">
                                <div class="Left">{{ $t('number77') }}</div>
                                <div class="right">{{ param.modelDetails.order.intl_shipping_number }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="status">
                        <div class="content">
                            <div class="item">
                                <div class="Left">
                                    {{ $t('number52') }}:
                                </div>
                                <div class="right">
                                  
                                    <span >
                                        {{ fomartPayState(param.modelDetails.order.status) }}
                                    </span>
                                   
                                </div>
                            </div>
                            <div class="item">
                                <div class="Left">
                                    {{ $t('number82') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.created_at * 1000) }}
                                </div>
                            </div>
                            <div class="item" v-if="param.modelDetails.order.pay_time">
                                <div class="Left">
                                    {{ $t('number107') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.pay_time * 1000) }}
                                </div>
                            </div>
                            <div class="item" v-if="param.modelDetails.order.delivery_time">
                                <div class="Left">
                                    {{ $t('cart64') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.delivery_time * 1000) }}
                                </div>
                            </div>




                            <div class="item" v-if="param.modelDetails.order.store_time">
                                <div class="Left">
                                    {{ $t('setup540') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.store_time) }}
                                </div>
                            </div>
                            <div class="item" v-if="param.modelDetails.order.outbound_time">
                                <div class="Left">
                                    {{ $t('setup541') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.outbound_time) }}
                                </div>
                            </div>
                            <div class="item"
                                v-if="param.modelDetails.order.updated_at != 0 && param.modelDetails.order.status == 10">
                                <div class="Left">
                                    {{ $t('setup82') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.updated_at * 1000) }}
                                </div>
                            </div>
                            <div class="item"
                                v-if="param.modelDetails.order.updated_at != 0 && param.modelDetails.order.status == 4">
                                <div class="Left">
                                    {{ $t('setup45') }}:
                                </div>
                                <div class="right">
                                    {{ formatToLocalTime(ipTime, param.modelDetails.order.updated_at) }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="productinfo">
                <div class="product">
                    <div class="orderTime">
                        <p>{{ $t('number49') }} : {{ param.modelDetails.order.order_no }}</p>
                        <!-- 国内物流单号 -->
                        <p class="time" v-if="param.modelDetails.order?.shipping_number">{{ $t('number77') }}:{{
                            param.modelDetails.order?.shipping_number }}</p>
                        <!-- 国际物流单号 -->
                    </div>
                    <div class="thead" style="background: #FF9845; color: #FFFFFF;">
                        <div class="name">{{ $t('cart69') }}</div>
                        <div class="sku" style="text-align: center;">{{ $t('setup444') }}</div>
                        <div class="price" style="text-align: center;">{{ $t('cart2') }}</div>
                        <div class="num" style="text-align: center;">{{ $t('cart3') }}</div>
                        <div class="Actual" style="text-align: end;"> {{ $t('setup445') }}</div>
                        <!-- <div class="status">{{ $t('number65') }}</div> -->
                    </div>

                    <div class="thead boderdiv" v-for="(item, index) in param.modelDetails.products" :key="index">
                        <div class="name"
                            @click="goUser(item.product_id, param.modelDetails.order.from, item.product_id)">
                            <div class="image"><img :src="item.cover_url" alt="" srcset=""></div>
                            <div class="info">
                                {{ item.product_name }}
                                <p class="norm" style="color: red;
    font-size: 14px;" v-if="param.modelDetails?.order?.needIntlPostage">
                                    {{ $t('setup670') }}
                                </p>
                            </div>
                           
                        </div>
                        <div class="sku formsize">
                            {{ item.sku_name }}
                        </div>
                        <div class="price formsize">
                            <!-- {{ symbolStatus(param.modelDetails.order.currency) }}{{item.price }} -->

                            <span v-if="param.modelDetails.order.currency == ''">{{ exchangeOrderRate(item.price
                                , userStore.exchangeRate.symbol, userStore.exchangeRate.currency,
                                userStore.exchangeRate.rate) }}</span>
                            <span v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{ item.price }}</span>

                        </div>
                        <div class="num formsize">{{ item.buy_num }}</div>
                        <div class="Actual formsize" style="font-size: 20px;color: #FC3938;text-align: end;">
                            <!-- {{ symbolStatus(param.modelDetails.order.currency) }}{{ item.total_price }} -->
                            <span v-if="param.modelDetails.order.currency == ''">{{ userStore.exchangeRate.symbol }}{{
                                item.totalValue }}</span>
                            <span v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{ item.total_price
                                }}</span>
                        </div>
                        <!-- <div class="status">{{ fomartPayState(param.modelDetails.order.status) }}</div> -->
                    </div>
                </div>
                <div class="amount" v-if="param.modelDetails.order.postage_price != 0">
                    <div style="display: flex;">
                        <div class="title">{{ $t('setup52') }} :</div>
                        <div class="red">
                            <span v-if="param.modelDetails.order.currency == ''">
                                {{ userStore.exchangeRate.symbol }}{{ exchangeOrderTotalRate(param.modelDetails.order.postage_price, 1, userStore.exchangeRate.symbol,
                                    userStore.exchangeRate.currency, userStore.exchangeRate.rate) }}</span>
                            <span v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{
                                param.modelDetails.order.postage_price}}</span>
                        </div>
                    </div>
                </div>
                <div class="amount">
                    <div style="display: flex;">
                        <div class="title">{{ $t('cart30') }} :</div>
                        <div class="red">
                            <span v-if="param.modelDetails.order.currency == ''">
                                <span v-if="param.modelDetails.order.postage_price != 0">
                                    <!-- 加运费 -->
                                    {{ userStore.exchangeRate.symbol }}{{ param.modelDetails?.totalValue +
                                        parseFloat(exchangeOrderTotalRate(param.modelDetails.order.postage_price, 1, userStore.exchangeRate.symbol,
                                    userStore.exchangeRate.currency, userStore.exchangeRate.rate)) }}
                                </span>
                                <span v-else>
                                    {{ userStore.exchangeRate.symbol }}{{ param.modelDetails?.totalValue }}
                                </span>
                            </span>
                            <span v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{
                                param.modelDetails.order.total_price}}</span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail" v-else>

            <TitleComponent :title="fomartPayState(param.modelDetails.order.status)"></TitleComponent>
            <!-- <div class="divcontent">
                <div @click="goBack()"><svg-icon icon-class="fanhui" /></div>
                <div>{{ fomartPayState(param.modelDetails.order.status) }}</div>
                <div> </div>
            </div> -->


            <div class="detailcontent">
                <div class="address">
                    <!-- <svg-icon icon-class="shohuodizhi" /> -->
                    <img src="../../assets/images/address3.png"
                        style="margin-top: 2px;width: 12px; height: 15px; margin-right: 9px;" alt="">
                    <div class="ellipsis-2 text" style="width: 300px;" v-if="addressshow == false"
                        @click="addressshow = !addressshow">

                        {{ param.modelDetails.shipping.shipping_name }}{{
                            param.modelDetails.shipping.shipping_phone }} {{ $t('cart68') }} {{
                            param.modelDetails.shipping.shipping_area }}
                    </div>
                    <div v-if="addressshow == true" @click="addressshow = !addressshow">
                        {{ param.modelDetails.shipping.shipping_name }}{{
                            param.modelDetails.shipping.shipping_phone }} {{ $t('cart68') }} {{
                            param.modelDetails.shipping.shipping_area }}
                    </div>
                </div>
                <div class="commodity">
                    <div class="Merchants"
                        >
                        <!-- @click="routers.push('/userDetails/' + param.modelDetails.shop_user.shop_user_id)" -->
                        {{ param.modelDetails.shop_user.shop_user }} </div>
                    <div v-for="(item, index) in param.modelDetails.products" :key="index"
                        style="padding-bottom: 10px;">

                        <div class="product">
                            <div class="productimg"
                                @click="goUser(item.product_id, param.modelDetails.order.from, item.product_id)">
                                <div class="cover"><img :src="item.cover_url" alt="" srcset=""></div>
                                <div>
                                    <div class="name ellipsis-2">{{ item.product_name }}</div>
                                    <div class="sku" style="padding-left: 10px;">{{ item.sku_name }}&nbsp;*{{
                                        item.buy_num }}</div>
                                         <div class="sku" style="color: red;" v-if="param.modelDetails?.order?.needIntlPostage">
                                    {{ $t('setup670') }}
                                </div>
                                    <div class="price">
                                        <!-- {{ symbolStatus(param.modelDetails.order.currency) }}{{ item.price }} -->
                                        <span
                                            v-if="param.modelDetails.order.currency == ''">{{ exchangeOrderRate(item.price
                                                , userStore.exchangeRate.symbol, userStore.exchangeRate.currency,
                                            userStore.exchangeRate.rate) }}</span>
                                        <span
                                            v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{ item.price }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="status">
                       
                        <span >
                            {{ fomartPayState(param.modelDetails.order.status) }}
                        </span>
                    </div>
                    <div class="info">
                        <div class="item" v-if="param.modelDetails.order.postage_price != 0">
                            <div class="Left">{{ $t('setup52') }}</div>
                            <div class="right">

                                <span
                                    v-if="param.modelDetails.order.currency == ''">{{ userStore.exchangeRate.symbol }}{{ exchangeOrderTotalRate(param.modelDetails.order.postage_price, 1, userStore.exchangeRate.symbol,
                                        userStore.exchangeRate.currency, userStore.exchangeRate.rate) }}</span>
                                <span v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{
                                    param.modelDetails.order.postage_price}}</span>

                            </div>
                        </div>
                        <div class="item">
                            <div class="Left">{{ $t('cart67') }}</div>
                            <div class="right">
                                <span v-if="param.modelDetails.order.currency == ''">
                                    <span v-if="param.modelDetails.order.postage_price != 0">
                                        <!-- 加运费 -->
                                        {{ userStore.exchangeRate.symbol }}{{ param.modelDetails?.totalValue +
                                            parseFloat(exchangeOrderTotalRate(param.modelDetails.order.postage_price, 1, userStore.exchangeRate.symbol,
                                        userStore.exchangeRate.currency, userStore.exchangeRate.rate)) }}
                                    </span>
                                    <span v-else>
                                        {{ userStore.exchangeRate.symbol }}{{ param.modelDetails?.totalValue }}
                                    </span>
                                </span>
                                <span v-else>{{ symbolStatus(param.modelDetails.order.currency) }}{{
                                    param.modelDetails.order.total_price}}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="Left">{{ $t('setup25') }}</div>
                            <div class="right">{{ payState(param.modelDetails.order.pay_type) }}
                            </div>
                        </div>
                        <div class="item" v-if="param.modelDetails.order.pay_type == 2">
                            <div class="Left">{{ $t('setup48') }}</div>
                            <div class="right">
                                {{ param.modelDetails.order.pay_result.bank_name }}

                                <img @click="drawer = true" v-if="param.modelDetails.order.pay_result.telegram"
                                    src="../../assets/images/telegram.png"
                                    style="width: 20px;height: 20px;margin-right: 5px;" alt="" srcset="">

                                <img @click="drawer = true" v-if="param.modelDetails.order.pay_result.watch_app"
                                    src="../../assets/images/watch.png"
                                    style="width: 20px;height: 20px;border-radius: 50%;    " alt="" srcset="">

                            </div>
                        </div>
                        <div class="item">
                            <div class="Left">{{ $t('number45') }}</div>
                            <div class="right" style="width: 224px;text-align: end;word-break: break-all;
    overflow-wrap: break-word;">{{ param.modelDetails.order.order_no }}</div>
                        </div>
                        <!-- 国内物流单号 -->
                        <div class="item" v-if="param.modelDetails.order.shipping_number">
                            <div class="Left">{{ $t('number77') }}</div>
                            <div class="right" style="width: 224px;text-align: end;word-break: break-all;
    overflow-wrap: break-word;">{{ param.modelDetails.order.shipping_number }}</div>
                        </div>
                        <!-- 国际物流单号 -->
                        <div class="item" v-if="param.modelDetails.order.intl_shipping_number">
                            <div class="Left">{{ $t('number77') }}</div>
                            <div class="right" style="width: 224px;text-align: end;word-break: break-all;
    overflow-wrap: break-word;">{{ param.modelDetails.order.intl_shipping_number }}</div>
                        </div>

                        <div class="item">
                            <div class="Left">{{ $t('cart66') }}</div>
                            <div class="right" style="width: 224px;text-align: end;word-break: break-all;
    overflow-wrap: break-word;">
                                {{ param.modelDetails.shipping.shipping_name }},{{
                                    param.modelDetails.shipping.shipping_area }},{{
                                    param.modelDetails.shipping.shipping_phone }}
                            </div>
                        </div>

                        <div class="item" v-if="param.modelDetails.order.created_at">
                            <div class="Left">{{ $t('number82') }}</div>
                            <div class="right"> {{ formatToLocalTime(ipTime, param.modelDetails.order.created_at * 1000)
                                }}</div>
                        </div>
                        <div class="item" v-if="param.modelDetails.order.pay_time">
                            <div class="Left">{{ $t('cart65') }}</div>
                            <div class="right">{{ formatToLocalTime(ipTime, param.modelDetails.order.pay_time * 1000) }}
                            </div>
                        </div>
                        <div class="item" v-if="param.modelDetails.order.delivery_time">
                            <div class="Left">{{ $t('cart64') }}</div>
                            <div class="right">{{ formatToLocalTime(ipTime, param.modelDetails.order.delivery_time * 1000)
                                }}</div>
                        </div>
                        <div class="item" v-if="param.modelDetails.order.store_time">
                            <div class="Left">
                                {{ $t('setup540') }}:
                            </div>
                            <div class="right">
                                {{ formatToLocalTime(ipTime, param.modelDetails.order.store_time) }}
                            </div>
                        </div>
                        <div class="item" v-if="param.modelDetails.order.outbound_time">
                            <div class="Left">
                                {{ $t('setup541') }}:
                            </div>
                            <div class="right">
                                {{ formatToLocalTime(ipTime, param.modelDetails.order.outbound_time) }}
                            </div>
                        </div>
                        <div class="item"
                            v-if="param.modelDetails.order.updated_at != 0 && param.modelDetails.order.status == 10">
                            <div class="Left">
                                {{ $t('setup82') }}:
                            </div>
                            <div class="right">
                                {{ formatToLocalTime(ipTime, param.modelDetails.order.updated_at * 1000) }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <el-drawer v-model="drawer" :title="t('cart23')" direction="btt" :before-close="handleClose" size="25%">
                <div>
                    <div v-if="param.modelDetails.bank.telegram">
                        <a :href="`${param.modelDetails.bank.telegram}`" target="_blank" rel="nofollow" class="button"
                            style="padding-right: 5px;">
                            <img @click="drawer = true" src="../../assets/images/telegram.png"
                                style="width: 20px;height: 20px;" alt="" srcset="">
                        </a>
                        {{ param.modelDetails.bank.telegram }}
                        <el-button type="warning" @click="handleCopy(param.modelDetails.bank.telegram)" size="small"
                            style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                    </div>
                    <div style="padding-top: 20px;" v-if="param.modelDetails.bank.watch_app">
                        <a :href="`${param.modelDetails.bank.watch_app}`" target="_blank" rel="nofollow" class="button"
                            style="padding-right: 5px;">
                            <img @click="drawer = true" src="../../assets/images/watch.png"
                                style="width: 20px;height: 20px;border-radius: 50%;    " alt="" srcset="">
                        </a>
                        {{ param.modelDetails.bank.watch_app }}
                        <el-button type="warning" @click="handleCopy(param.modelDetails.bank.watch_app)" size="small"
                            style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>
<script setup>
import { getContactDetailsAPI } from '@/apis/user'
import TitleComponent from '@/components/TitleComponent/index.vue'
import { MoreFilled } from '@element-plus/icons-vue'
import { getOrderDetailAPI } from '@/apis/order'
import routers from '@/router';
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { formatToLocalTime, exchangeOrderRate, fomartPayState, payState, symbolStatus, exchangeOrderTotalRate } from '@/utils/index'
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()
const ipTime = userStore.ipTime;
const { t } = useI18n();
let router = useRoute()
const orderon = ref(router.params.id)
const order_type = ref(router.params.type)
const drawer = ref(false)
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    getorderDetails()
    getContactDetails()
})
//复制
const handleCopy = async (text) => {
    navigator.clipboard.writeText(text)
        .then(() => {
            ElMessage({ type: 'success', message: t('cart74') });
        })
        .catch(err => {
            ElMessage({ type: 'error', message: t('cart75') });
        });
    // try {
    //     await toClipboard(text);
    //     ElMessage({ type: 'success', message: t('cart74') });
    // } catch (e) {
    //     ElMessage({ type: 'error', message: t('cart75') });
    // }
}
const handleClose = () => {
    drawer.value = false
}

const goBack = () => {
    routers.go(-1);
}
const addressshow = ref(false)

const goUser = (id, type, productid) => {
    console.log('zhi--type', type)
    console.log(111111)
    if (type) {
        let data = { product_id: productid, from: type }
        let objectString = JSON.stringify(data);
        localStorage.setItem('thirdData', objectString)
        // routers.push('/externals')
        routers.push({ path: '/externals/' + type + '/' + productid })
    } else {
        routers.push('/detail/' + id)
    }

}
/**
 * 获取联系方式
 */
const getContactDetails = async () => {
    const res = await getContactDetailsAPI()
    if (res.code == 0) {
        console.log(res.data)
        param.contactData = res.data.data[0]

    }

}

const param = reactive({
    modelDetails: {
        order: {},
        shipping: {},
        product: [],
        bank: {},
        shop_user: {}
    },
    contactData: {}
})
const getorderDetails = async () => {
    console.log(router.params.type)
    const res = await getOrderDetailAPI({ order_no: orderon.value, order_type: order_type.value })
    if (res.code == 0) {
        let data = res.data

        data.products.forEach((group) => {
            group.totalValue = parseFloat(exchangeOrderTotalRate(group.price, group.buy_num, userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate));
        });
        // 计算 products 数组中所有 totalValue 的总和
        data.totalValue = data.products.reduce((sum, product) => {
            return sum + product.totalValue;
        }, 0);
        console.log('数据值', data)
        param.modelDetails = data
        // step.value = res.data.order.status
        // if (step.value == 3) {
        //     step.value = 2
        // } else if (step.value == 4) {
        //     step.value = 3
        // } else if (step.value == 5) {
        //     if (res.data.order.pay_time == 0) {
        //         step.value = 1
        //     } else {
        //         step.value = 2
        //     }

        // }

    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
</script>
<style scoped lang="scss">
.orderDetailsDIV {
    background: #eef0f1;
    height: auto;
    user-select: text;
}

.orderDetails {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    // background-color: #fff;

    .top {
        border: 1px solid #FFFFFF;
        background: #FFFFFF;
        border-radius: 8px;
        margin-top: 22px;
        margin-bottom: 20px;

        .top-title {
            height: 56px;
            background: #F3F6F8;
            display: flex;
            margin: 30px 20px 0 20px;

            .title {
                height: 56px;
                background: #F3F6F8;
                font-size: 16px;
                // background-color: #f1f1f1
                padding: 17px 0 20px 24px;
                display: flex;
                justify-content: space-between;
                // border: 1px solid #d8d8d8;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #11192D;
                line-height: 19px;
                text-align: left;
                font-style: normal;
            }

            .statusW {
                width: 346px;

            }
        }

        .Order {
            // border: 1px solid yellow;
            display: flex;
            // border: 1px solid #d8d8d8;
            margin: 0px 21px 30px 21px;
            border-radius: 0px 0px 8px 8px;
            border: 1px solid #E5E8EC;
            border-top: #F3F6F8;

            .address {
                flex: 1;
                // border-right: 1px solid #d8d8d8;


            }

            .content {
                padding: 10px 20px;
                border-radius: 0px 0px 0px 8px;

                // border-left: 1px solid #E5E8EC;
                // border-bottom: 1px solid #E5E8EC;
                .item {
                    display: flex;
                    // padding: 10px 0;s

                    .Left {
                        // width: 90px;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #666666;
                        line-height: 36px;
                        text-align: left;
                        font-style: normal;
                        margin-right: 10px;
                    }

                    .right {
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #11192D;
                        line-height: 36px;
                        text-align: left;
                        font-style: normal;
                    }
                }


            }

            .status {
                width: 350px;
            }
        }
    }

    .productinfo {
        background: #FFFFFF;
        border-radius: 8px;
        padding: 30px 20px 40px 20px;
        margin-bottom: 40px;

        .product {
            .orderTime {
                background: #F3F6F8;
                border-radius: 8px 8px 0px 0px;
                padding: 10px 20px;
                display: flex;
                justify-content: space-between;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #000000;
                line-height: 19px;
                text-align: left;
                font-style: normal;

                .time {
                    padding-left: 20px;
                }
            }

            .thead {
                display: flex;
                align-items: center;
                padding: 15px 20px;

                font-family: MicrosoftYaHei;
                font-size: 14px;
                // color: #FFFFFF;
                line-height: 19px;
                text-align: left;
                font-style: normal;

                .name {
                    flex: 1;
                    display: flex;

                    .image {
                        width: 82px;
                        height: 82px;
                        border: 1px solid #f5f5f5;
                        border-radius: 8px;

                        img {
                            border-radius: 8px;
                            width: 100%;
                        }
                    }

                    .info {
                        width: 369px;
                        text-align: left;
                        padding: 0 10px;
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #11192D;
                        line-height: 25px;
                        text-align: left;
                        font-style: normal;

                        p {
                            // margin-bottom: 5px;

                            &.name {
                                height: 38px;
                            }

                            &.attr {
                                color: #999;
                                font-size: 12px;

                                span {
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }

                .formsize {
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #666666;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                    text-align: center;
                }

                .sku {

                    width: 170px;
                }

                .price {
                    width: 120px;
                }

                .num {
                    width: 120px;
                }

                .status {
                    width: 120px;
                }

                .Actual {
                    width: 130px;
                }

            }

            .boderdiv {
                border-left: 1px solid #f5f5f5;
                border-bottom: 1px solid #f5f5f5;
                border-right: 1px solid #f5f5f5;
            }
        }

        .amount {
            padding-top: 40px;
            font-size: 18px;
            // background-color: #f1f1f1;
            // padding: 10px 20px;
            display: flex;
            justify-content: flex-end;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #0F0F0F;
            line-height: 19px;
            text-align: left;
            font-style: normal;

            p {
                width: 290px;
                display: flex;
                justify-content: space-between;

                .title {
                    text-align: end;
                    width: 190px;
                }
            }
        }

        .red {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 24px;
            color: #FC3938;
            line-height: 19px;
            text-align: left;
            font-style: normal;
        }

    }



}

@media (max-width: 768px) {
    .orderDetailsDIV {
        // background: #eef0f1;
        height: 100%;
    }

    .detail {
        z-index: 99999;
        height: 100%;
        background: #f0f0f0;

        .top {
            position: fixed;
            background: #fff;
            width: 100%;
            height: 45px;
            z-index: 9999;
            // padding: 0 20px;

            .divcontent {
                font-size: 16px;
                display: flex;
                justify-content: space-between;
                /* padding: 13px 0; */
                height: 45px;
                align-items: center;

            }

        }

        .detailcontent {
            background-color: #f0f1f3;
            // padding-top: 50px;
            padding: 65px 15px 25px 15px;
            height: auto;

            .address {
                display: flex;
                padding: 13px 15px;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px 6px rgba(237, 237, 237, 0.75);
                border-radius: 8px;

                .text {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222222;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                }
            }

            .commodity {
                margin-top: 15px;
                padding: 15px 15px 20px 15px;
                height: 100%;
                background: #FFFFFF;
                box-shadow: 0px 4px 20px 6px rgba(237, 237, 237, 0.75);
                border-radius: 4px;
                // overflow-y: auto;

                .Merchants {
                    padding: 10px 0;
                }

                .product {
                    display: flex;

                    .productimg {
                        display: flex;
                        flex: 1;

                        .cover {
                            width: 82px;
                            height: 82px;
                            // border: 1px solid;
                            border-radius: 8px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 8px;
                            }
                        }

                        .name {
                            padding-left: 11px;
                            width: 233px;
                        }

                        .sku {
                            padding-left: 11px;
                            width: 233px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #888888;
                            line-height: 17px;
                            text-align: left;
                            font-style: normal;
                        }
                    }

                    .price {
                        padding-top: 10px;
                        padding-left: 7px;
                        // align-items: flex-end;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FC3938;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal;
                    }
                }

                .status {
                    background: #FFF1EB;
                    border-radius: 4px;
                    // margin-left: 110px;
                    padding: 5px 17px 5px 5px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FC3938;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-align: end;
                }

                .info {
                    padding: 10px 0;

                    .item {
                        padding: 10px 0;
                        display: flex;
                        justify-content: space-between;

                        .Left {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #222222;
                            line-height: 14px;
                            text-align: left;
                            font-style: normal;
                        }

                        .right {
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #888888;
                            line-height: 14px;
                            text-align: center;
                            font-style: normal;
                        }
                    }
                }

            }

        }
    }
}
</style>